import { compose } from 'redux';
import { connect } from 'react-redux';

import routeDependencies from 'utilities/routeDependencies';
import { loadable } from 'modules/layout';

import InfoPage from '../../components/InfoPage';

import { infoDetailRequest } from '../../services/actions';
import { selectInfoDetailPending } from '../../services/selectors';

export default compose(
    connect(
        (state, { match: { params } }) => ({
            id: params.id,
            categoryId: params.categoryId,
            showLoader: selectInfoDetailPending(state),
        }),
        (dispatch, { match: { params } }) => ({
            read: () => {
                dispatch(infoDetailRequest(params.categoryId, params.id));
            },
        }),
    ),
    routeDependencies(),
    loadable,
)(InfoPage);
